/**
 * OnlineDocsDialog — the profile menu's "Online Documentation".
 *
 * Port of legacy components/HeaderModals/helperModal.vue: a wide dialog with
 * the guide for the page being shown (helpTopics.js picks it), closed by ✕,
 * Esc or a click outside. Each guide is legacy's text, verbatim, in its own
 * file under topics/ — and its own chunk: the guides are long and only ever
 * read on demand, so none of them ships with the app bar.
 */
import { lazy, Suspense } from 'react';

import { Modal, Spinner } from '@components/ui';

import styles from './OnlineDocs.module.css';
import { HELP_TOPICS } from './topics';

export { helpTopicFor } from './helpTopics';

// One lazy component per topic, made once: a new lazy() on every render would
// suspend (and flash the spinner) each time.
const lazyTopics = new Map();
function topicComponent(id) {
  if (!lazyTopics.has(id)) lazyTopics.set(id, lazy(HELP_TOPICS[id].load));
  return lazyTopics.get(id);
}

export function OnlineDocsDialog({ topic, onClose }) {
  const entry = HELP_TOPICS[topic];
  if (!entry) return null;
  const Topic = topicComponent(topic);

  return (
    <div className={styles.size}>
      <Modal open onClose={onClose} title={entry.title}>
        <Suspense
          fallback={
            <div className={styles.loading}>
              <Spinner />
            </div>
          }
        >
          <div className={styles.doc}>
            <Topic />
          </div>
        </Suspense>
      </Modal>
    </div>
  );
}

export default OnlineDocsDialog;
